<template>
  <div class="subpage-card balance-page">
    <div class="balance-page__head">
      <div>
        <h2 class="balance-page__title">היתרה ורכישות</h2>
        <p class="balance-page__sub muted">
          ניהול הלינקטונים שרכשתם — מה זמין, מה כבר נוצל, ורכישת חבילות נוספות.
        </p>
      </div>
      <div class="balance-page__total-wrap">
        <div class="muted balance-page__total-label">סה״כ זמין</div>
        <div class="balance-page__total">
          {{ total }}
          <span class="balance-page__total-unit">לינקטונים</span>
        </div>
      </div>
    </div>

    <h4 class="balance-page__section-title">יתרה זמינה לשליחה</h4>
    <div class="balance-slots">
      <div v-for="t in slotTypes" :key="t.id" class="balance-slot">
        <div class="balance-slot__label">
          <LtIcon :name="t.icon" :size="14" />
          {{ t.label }}
        </div>
        <div class="balance-slot__num">{{ balance[t.id] || 0 }}</div>
        <div class="muted balance-slot__hint">לינקטונים זמינים</div>
      </div>
    </div>

    <h4 class="balance-page__section-title">רכישת לינקטונים נוספים</h4>
    <div class="purchase-grid">
      <div
        v-for="opt in products"
        :key="opt.id"
        class="purchase-card"
        :class="{ 'is-featured': opt.featured }"
      >
        <span v-if="opt.featured" class="purchase-card__badge">הכי משתלם</span>
        <div class="purchase-card__icon">
          <LtIcon :name="opt.icon" :size="18" />
        </div>
        <div class="purchase-card__name">{{ opt.name }}</div>
        <div class="muted purchase-card__note">{{ opt.note }}</div>
        <div class="purchase-card__price">₪{{ formatPrice(opt.price) }}</div>
        <button
          type="button"
          class="btn btn--sm"
          :class="opt.featured ? 'btn--primary' : 'btn--ghost'"
          @click="$emit('buy', opt)"
        >
          <LtIcon name="plus" :size="14" /> רכישה
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';

export default {
  name: 'BalancePage',
  components: { LtIcon },
  props: {
    balance: { type: Object, required: true },
    products: { type: Array, default: () => [] },
  },
  emits: ['buy'],
  data() {
    return {
      slotTypes: [
        { id: 'single', label: 'רגיל', icon: 'disc' },
        { id: 'ep', label: 'EP', icon: 'music' },
        { id: 'album', label: 'אלבום', icon: 'album' },
      ],
    };
  },
  computed: {
    total() {
      return (this.balance.single || 0) + (this.balance.ep || 0) + (this.balance.album || 0);
    },
  },
  methods: {
    formatPrice(price) {
      return price.toLocaleString('he-IL');
    },
  },
};
</script>
